<ng-template #content let-company="company">
  <h2 class="ibk-description" *ngIf="!addressForm">
    Datos de tu negocio
  </h2>
  <p class="ibk-description" *ngIf="addressForm">
    Datos Representante Legal
  </p>
  <ba-outside-tax> ¿Tu empresa tiene residencia fiscal o tributaria en Perú? </ba-outside-tax>

  <ibk-toast type="INFO" *ngIf="showContinueDisclaimer">
    Al marcar “Si” declaro bajo juramento que la información proporcionada es veraz, completa y actualizada, de
    conformidad con la Ley 26702 (Ley General del Sistema Financiero) y el Decreto Supremo 256-2018-EF (Información
    financiera que los bancos deben comunicar a SUNAT).
  </ibk-toast>

  <ibk-toast type="ERROR" *ngIf="showErrorDisclaimer">
    Lo sentimos, la creación de esta cuenta requiere que tu empresa posea residencia y obligaciones fiscales y
    tributarias solo en Perú.
  </ibk-toast>

  <h1 class="ibk-title">Datos de la empresa</h1>
  <ng-container formGroupName="companyData">
    <ibk-toast type="ERROR" *ngIf="showStopFlow">
      De acuerdo a nuestras políticas internas no podemos atender tu solicitud. Para mayor información puedes
      comunicarte a nuestra Banca Telefónica.
    </ibk-toast>

    <div class="ba-field-group">
      <ibk-input-group
        *ngIf="!company?.societyType"
        [ngClass]="{ 'single-child': !company?.constitutionDate ? false : true }"
      >
        <label>Tipo de contribuyente</label>
        <ibk-select dsRxForm="selectChange" formControlName="societyType" class="field">
          <ibk-select-option
            *ngFor="let option of paramsService.params$('societyType') | async"
            [value]="option.value"
            [label]="option.label"
          ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <ibk-input-group
        *ngIf="!company?.constitutionDate"
        [ngClass]="{ 'single-child': !company?.societyType ? false : true }"
      >
        <label>Fecha de constitución</label>
        <ibk-input icon="event">
          <input class="input-date-picker" readonly #endDate appDatePickerControl formControlName="constitutionDate" />
          <ibk-date-picker [el]="endDate" [config]="ibkConfig"></ibk-date-picker>
        </ibk-input>
      </ibk-input-group>
    </div>
  </ng-container>

  <div class="ba-field-group">
    <ibk-input-group name="registration-number">
      <label>Número de partida registral</label>
      <ibk-input char-filter="^[0-9]{1,8}$">
        <input
          [disabled]="showErrorDisclaimer"
          minlength="8"
          maxlength="8"
          formControlName="registrationNumber"
          class="ibk-input--min-width"
          type="text"
        />
      </ibk-input>
    </ibk-input-group>
  </div>

  <p class="reg-reminder">
    <ibk-info-icon class="icon"></ibk-info-icon>
    <span>
      ¿No recuerdas tu número de partida registral?
      <a href="https://www.sunarp.gob.pe/bus-personas-juridicas.asp" target="_blank" class="ibk-link">
        Conócelo aquí
      </a>
    </span>
  </p>

  <ng-container *ngIf="!showStopFlow">
    <div class="ba-field-group" formGroupName="sectorData">
      <ibk-input-group [ngClass]="{ 'single-child': subrubrosList.length === 0 ? true : false }">
        <label>Selecciona el rubro de tu negocio (*)</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="sectorCode">
          <ibk-select-option *ngFor="let option of rubros" [value]="option.value" [label]="option.label">
          </ibk-select-option>
        </ibk-select>
      </ibk-input-group>

      <ibk-input-group *ngIf="subrubrosList.length !== 0">
        <label>Selecciona la actividad de tu negocio</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="subSectorCode">
          <ibk-select-option *ngFor="let option of subrubrosList" [value]="option.value" [label]="option.label">
          </ibk-select-option>
        </ibk-select>
      </ibk-input-group>
    </div>
    <ibk-toast type="ERROR" *ngIf="isForbiddenSubsector">
      Lo sentimos, actualmente no podemos aperturar cuentas con este subrubro.
    </ibk-toast>
    <ibk-toast type="ERROR" *ngIf="isForbiddenSector">
      Lo sentimos, actualmente no podemos aperturar cuentas con este rubro.
    </ibk-toast>
    <br *ngIf="isForbiddenSubsector || isForbiddenSector"/>
    <ibk-input>
      <input type="checkbox" [formControl]="$any(form.get('areSectorAndSubsectorValid'))" (change)="chBusinessActivity($event)"/>
      Declaro que el rubro y actividad de mi negocio son datos verídicos.
    </ibk-input>
    <ibk-toast type="INFO" *ngIf="showToastBusinessActivity">
      Al marcar declaro bajo juramento que la informaci&oacute;n proporcionada es veraz, completa y actualizada, de conformidad con
      la Ley 26702 (Ley General del Sistema Financiero) y el Decreto Supremo 256-2018-EF (Informaci&oacute;n financiera que  los
      bancos deben comunicar a SUNAT).
    </ibk-toast>
  </ng-container>

  <ng-container formGroupName="companyData" *ngIf="!isClient">
    <p>
      <b>
        Br&iacute;ndanos los siguientes datos:
      </b>
    </p>
    <div class="ba-field-group">
      <ibk-input-group name="registration-number">
        <label>RUC de la empresa (*)</label>
        <ibk-input char-filter="^[0-9]{1,8}$">
          <input class="ibk-input--min-width" formControlName="ruc" type="text" maxlength="11" [disabled]="true" />
        </ibk-input>
      </ibk-input-group>

      <ibk-input-group name="registration-number">
        <label>Razón social (*)</label>
        <ibk-input>
          <input
            [disabled]="showErrorDisclaimer"
            class="ibk-input--min-width"
            formControlName="businessName"
            type="text"
          />
        </ibk-input>
      </ibk-input-group>
    </div>
  </ng-container>

  <div class="ba-field-group" formGroupName="companyData">
    <ibk-input-group name="registration-number">
      <label>Email de tu negocio (*)</label>
      <ibk-input>
        <input [disabled]="showErrorDisclaimer" class="ibk-input--min-width" type="text" formControlName="email" />
      </ibk-input>
    </ibk-input-group>

    <ibk-input-group name="registration-number">
      <label>Confirma el email (*)</label>
      <ibk-input>
        <input
          [disabled]="showErrorDisclaimer"
          class="ibk-input--min-width"
          type="text"
          formControlName="confirmEmail"
        />
      </ibk-input>
    </ibk-input-group>
    <p class="error-message" *ngIf="form.get('companyData')?.errors?.['missmatch']">Los correos no coinciden</p>
  </div>

  <ng-container *ngIf="addressForm" [formGroup]="addressForm">
    <ba-address-form></ba-address-form>
    <ibk-input *ngIf="!isClient">
      <input type="checkbox" [formControl]="$any(form.get('isSameAddressCompanyAndLegalRepresentant'))" />
      La dirección de la empresa previamente declarada es la misma de mi domicilio.
    </ibk-input>
  </ng-container>
  <ng-container *ngIf="hasPartnersForm || usePartnersForm" formGroupName="partnerList">
    <ba-partners-list-form
      (newPartnerRequest)="addNewPartner()"
      (removePartnerRequest)="removePartner($event)"
      *ngIf="usePartnersForm"
    ></ba-partners-list-form>
  </ng-container>

  <ibk-button class="ba-action" [loading]="isLoading">
    <button (click)="done()" [disabled]="form.invalid || disableBtnContinue" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn">
      Continuar
    </button>
  </ibk-button>
</ng-template>

<ng-container *ngTemplateOutlet="content; context: { company: (company$ | async)?.company ?? null }"></ng-container>
